import { render, staticRenderFns } from "./ModalTransactionInfo.vue?vue&type=template&id=4ac0da42"
import script from "./ModalTransactionInfo.vue?vue&type=script&lang=js"
export * from "./ModalTransactionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports